var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarSmall = function SvgStarSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F29100",
    d: "M7.252 2.365a.829.829 0 0 1 1.496 0l1.124 2.294c.123.25.358.424.63.463l2.493.365c.69.101.964.97.461 1.463l-1.789 1.756a.87.87 0 0 0-.244.763l.424 2.492c.119.697-.595 1.23-1.209.906l-2.253-1.193a.82.82 0 0 0-.77 0l-2.253 1.193c-.615.325-1.328-.21-1.21-.906l.425-2.492a.87.87 0 0 0-.244-.763L2.543 6.95c-.502-.494-.228-1.362.462-1.463l2.493-.365a.84.84 0 0 0 .63-.463z"
  })));
};
export default SvgStarSmall;